import UnfoldMoreIcon from '@mui/icons-material/UnfoldMore';
import { Box, TableCell, TableHead, TableRow, Typography } from '@mui/material';
import zeplinColor from 'theme/Color';
import { headerRowStyles, TABLE_COLUMNS } from '../../constants';

export const TasksTableHeader = () => {
  return (
    <TableHead>
      <TableRow sx={headerRowStyles}>
        {TABLE_COLUMNS.map((column) => (
          <TableCell
            key={column.id}
            align={column.align}
            style={{ minWidth: column.minWidth }}
          >
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
              <Typography variant='body3'>{column.label}</Typography>
              <Box
                sx={{
                  width: 16,
                  height: 16,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                <UnfoldMoreIcon
                  sx={{
                    fontSize: 16,
                    color: zeplinColor.BasicBlack,
                    opacity: 0.5,
                  }}
                />
              </Box>
            </Box>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
};
